var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTemplate3Web = function SvgTemplate3Web(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M13.3333 5.33203H5.33333C4.59695 5.33203 4 5.92898 4 6.66536V11.9987C4 12.7351 4.59695 13.332 5.33333 13.332H13.3333C14.0697 13.332 14.6667 12.7351 14.6667 11.9987V6.66536C14.6667 5.92898 14.0697 5.33203 13.3333 5.33203Z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M26.6666 5.33203H18.6666C17.9302 5.33203 17.3333 5.92898 17.3333 6.66536V11.9987C17.3333 12.7351 17.9302 13.332 18.6666 13.332H26.6666C27.403 13.332 27.9999 12.7351 27.9999 11.9987V6.66536C27.9999 5.92898 27.403 5.33203 26.6666 5.33203Z",
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M6.66667 17.332H5.33333C4.59695 17.332 4 17.929 4 18.6654V23.9987C4 24.7351 4.59695 25.332 5.33333 25.332H6.66667C7.40305 25.332 8 24.7351 8 23.9987V18.6654C8 17.929 7.40305 17.332 6.66667 17.332Z",
    stroke: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M13.3334 17.332H12.0001C11.2637 17.332 10.6667 17.929 10.6667 18.6654V23.9987C10.6667 24.7351 11.2637 25.332 12.0001 25.332H13.3334C14.0698 25.332 14.6667 24.7351 14.6667 23.9987V18.6654C14.6667 17.929 14.0698 17.332 13.3334 17.332Z",
    stroke: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M19.9999 17.332H18.6666C17.9302 17.332 17.3333 17.929 17.3333 18.6654V23.9987C17.3333 24.7351 17.9302 25.332 18.6666 25.332H19.9999C20.7363 25.332 21.3333 24.7351 21.3333 23.9987V18.6654C21.3333 17.929 20.7363 17.332 19.9999 17.332Z",
    stroke: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M26.6667 17.332H25.3333C24.597 17.332 24 17.929 24 18.6654V23.9987C24 24.7351 24.597 25.332 25.3333 25.332H26.6667C27.403 25.332 28 24.7351 28 23.9987V18.6654C28 17.929 27.403 17.332 26.6667 17.332Z",
    stroke: "currentColor"
  })));
};
export default SvgTemplate3Web;